import type { GoalStateEnum } from "web_myplann/Infrastructure/Api/Api";

export const GoalsKeys = {
	all: ["goals"] as const,
	lists: () => [...GoalsKeys.all, "list"] as const,
	list: (filterStates?: GoalStateEnum[]) =>
		[...GoalsKeys.lists(), { filterStates }] as const,
	overview: () => [...GoalsKeys.lists(), "overview"] as const,
	detail: (id: number | null) => [...GoalsKeys.all, "detail", id] as const,
	detailPortfolios: () => [...GoalsKeys.all, "detailPortfolios"] as const,
};
